var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 44,
    viewBox: "0 0 144 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_196_3809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2323 0H0.96192C0.70272 0 0.4608 0.1056 0.28224 0.287467C0.10368 0.469333 0 0.7216 0 0.979733V43.0203C0 43.2784 0.10368 43.5307 0.28224 43.7125C0.4608 43.8944 0.70848 44 0.96192 44H42.2381C42.4915 44 42.7392 43.8944 42.9178 43.7125C43.0963 43.5307 43.2 43.2784 43.2 43.0203V0.979733C43.2 0.7216 43.0963 0.469333 42.9178 0.287467C42.7334 0.1056 42.4915 0 42.2323 0ZM28.7942 28.3536C28.7942 28.6117 28.6906 28.864 28.512 29.0459C28.3334 29.2277 28.0858 29.3333 27.8323 29.3333H15.3562C15.1027 29.3333 14.855 29.2277 14.6765 29.0459C14.4979 28.864 14.3942 28.6117 14.3942 28.3536V15.6464C14.3942 15.3883 14.4979 15.136 14.6765 14.9541C14.855 14.7723 15.1027 14.6667 15.3562 14.6667H27.8323C28.0858 14.6667 28.3334 14.7723 28.512 14.9541C28.6906 15.136 28.7942 15.3883 28.7942 15.6464V28.3536Z",
    fill: "#13599D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.649 14.6667H116.173C115.643 14.6667 115.211 15.1067 115.211 15.6465V28.3537C115.211 28.8934 115.643 29.3334 116.173 29.3334H128.649C129.179 29.3334 129.611 28.8934 129.611 28.3537V15.6465C129.605 15.1067 129.179 14.6667 128.649 14.6667Z",
    fill: "#13599D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.245 0.00585938H101.769C101.239 0.00585938 100.807 0.445859 100.807 0.985593V13.6928C100.807 14.2325 101.239 14.6725 101.769 14.6725H114.245C114.775 14.6725 115.207 14.2325 115.207 13.6928V0.979726C115.207 0.439993 114.775 0.00585938 114.245 0.00585938Z",
    fill: "#13599D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.038 0.00585938H130.562C130.032 0.00585938 129.6 0.445859 129.6 0.985593V13.6928C129.6 14.2325 130.032 14.6725 130.562 14.6725H143.038C143.568 14.6725 144 14.2325 144 13.6928V0.979726C144 0.439993 143.568 0.00585938 143.038 0.00585938Z",
    fill: "#13599D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.245 29.3333H101.769C101.239 29.3333 100.807 29.7733 100.807 30.313V43.0202C100.807 43.5599 101.239 43.9999 101.769 43.9999H114.245C114.775 43.9999 115.207 43.5599 115.207 43.0202V30.313C115.207 29.7674 114.775 29.3333 114.245 29.3333Z",
    fill: "#13599D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.038 29.3333H130.562C130.032 29.3333 129.6 29.7733 129.6 30.313V43.0202C129.6 43.5599 130.032 43.9999 130.562 43.9999H143.038C143.568 43.9999 144 43.5599 144 43.0202V30.313C144 29.7674 143.568 29.3333 143.038 29.3333Z",
    fill: "#13599D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6256 0.00585938H80.1494C79.6195 0.00585938 79.1875 0.445859 79.1875 0.985593V13.6928C79.1875 14.2325 79.6195 14.6725 80.1494 14.6725H92.6256C93.1555 14.6725 93.5875 14.2325 93.5875 13.6928V0.979726C93.5875 0.439993 93.1555 0.00585938 92.6256 0.00585938Z",
    fill: "#13599D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6256 29.3333H80.1494C79.6195 29.3333 79.1875 29.7733 79.1875 30.313V43.0202C79.1875 43.5599 79.6195 43.9999 80.1494 43.9999H92.6256C93.1555 43.9999 93.5875 43.5599 93.5875 43.0202V30.313C93.5875 29.7674 93.1555 29.3333 92.6256 29.3333Z",
    fill: "#13599D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1888 15.6347C79.1888 15.3765 79.0851 15.1243 78.9065 14.9424C78.728 14.7605 78.4803 14.6549 78.2268 14.6549H64.7888V0.979733C64.7888 0.7216 64.6851 0.469333 64.5065 0.287467C64.328 0.1056 64.0803 0 63.8268 0H51.3564C51.103 0 50.8553 0.1056 50.6768 0.287467C50.4982 0.469333 50.3945 0.7216 50.3945 0.979733V42.9968C50.3945 43.2549 50.4982 43.5072 50.6768 43.6891C50.8553 43.8709 51.103 43.9765 51.3564 43.9765H63.8326C64.086 43.9765 64.3337 43.8709 64.5123 43.6891C64.6908 43.5072 64.7945 43.2549 64.7945 42.9968V29.3216H78.2326C78.486 29.3216 78.7337 29.216 78.9123 29.0341C79.0908 28.8523 79.1945 28.6 79.1945 28.3419L79.1888 15.6347Z",
    fill: "#13599D",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_196_3809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkx);
export default __webpack_public_path__ + "static/media/okx.20930e14892fc24d42a104ac841bb505.svg";
export { ForwardRef as ReactComponent };